// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2zqaE","col":"styles_col__3vPK-","fulfillmentStatus":"styles_fulfillmentStatus__ywS5k","emailCol":"styles_emailCol__1zrJE"};